import { MEDIA_STATUS_LABELS } from '../../constants'
import { useSearch } from '../../hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import { CheckboxGroup } from '../baseInputTypes/FilterCheckboxGroup'

export const MediaStatus = () => {
  const { selectors, updateNext } = useSearch()

  const nextSearchOptions = useAppSelector(selectors.selectNextSearchParameters)

  return (
    <CheckboxGroup
      label="Status"
      fieldName="status"
      state={nextSearchOptions.status}
      checkboxDetails={MEDIA_STATUS_LABELS}
      onChange={(key, checked) => updateNext({ status: { [key]: checked } })}
    />
  )
}
